import React from 'react';
import { Link } from 'react-router-dom';
import SignUpForm from '@/components/SignUpForm';
import PlatformLogo from '@/components/PlatformLogo';

const SignUp = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-vitl-green/5 via-white to-vitl-blue/5">
      {/* Header */}
      <div className="bg-white/95 backdrop-blur-sm border-b border-vitl-dark/10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <PlatformLogo />
            </Link>
            <Link 
              to="/" 
              className="text-sm text-vitl-dark/70 hover:text-vitl-green transition-colors"
            >
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-vitl-navy mb-3">
            Create Your VITL Account
          </h1>
          <p className="text-lg text-vitl-dark/70 max-w-2xl mx-auto">
            Join our network of healthcare providers and access our comprehensive pharmacy services
          </p>
        </div>
        
        <SignUpForm />
      </div>
    </div>
  );
};

export default SignUp;